// extracted by mini-css-extract-plugin
export default {"cookies":"cookies_cookies__Lq5UR","window":"cookies_window__r7jTQ","inner":"cookies_inner__I227W"};